import React from "react";
import { Route, Routes } from "react-router-dom";

import { pageNotFound } from "lib/errorHandler";

import { CookiePolicyPage } from "./cookiePolicy";
import { DeviceInfoPage } from "./deviceInfo";
import { SupportPage } from "./indexPage";
import { InstructionsPage } from "./instructions";

export const SupportIndex: React.FC = () => {
  return (
    <Routes>
      {pageNotFound}
      <Route index element={<SupportPage />} />
      <Route path="cookie-policy" element={<CookiePolicyPage />} />
      <Route path="device-info" element={<DeviceInfoPage />} />
      <Route path="instructions" element={<InstructionsPage />} />
    </Routes>
  );
};
